import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _createForOfIteratorHelper from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function e(e, t, r, n) {
  return new (r || (r = Promise))(function (o, i) {
    function s(e) {
      try {
        c(n.next(e));
      } catch (e) {
        i(e);
      }
    }
    function a(e) {
      try {
        c(n.throw(e));
      } catch (e) {
        i(e);
      }
    }
    function c(e) {
      var t;
      e.done ? o(e.value) : (t = e.value, t instanceof r ? t : new r(function (e) {
        e(t);
      })).then(s, a);
    }
    c((n = n.apply(e, t || [])).next());
  });
}
var t = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function r(e) {
  if (e.__esModule) return e;
  var t = Object.defineProperty({}, "__esModule", {
    value: !0
  });
  return Object.keys(e).forEach(function (r) {
    var n = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(t, r, n.get ? n : {
      enumerable: !0,
      get: function get() {
        return e[r];
      }
    });
  }), t;
}
function n(e) {
  var t = {
    exports: {}
  };
  return e(t, t.exports), t.exports;
}
var o = n(function (e) {
  !function (t, r) {
    var n = {};
    !function (e) {
      e.__esModule = !0, e.digestLength = 32, e.blockSize = 64;
      var t = new Uint32Array([1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298]);
      function r(e, r, n, o, i) {
        for (var s, a, c, f, u, h, l, d, p, y, g, b, v; i >= 64;) {
          for (s = r[0], a = r[1], c = r[2], f = r[3], u = r[4], h = r[5], l = r[6], d = r[7], y = 0; y < 16; y++) g = o + 4 * y, e[y] = (255 & n[g]) << 24 | (255 & n[g + 1]) << 16 | (255 & n[g + 2]) << 8 | 255 & n[g + 3];
          for (y = 16; y < 64; y++) b = ((p = e[y - 2]) >>> 17 | p << 15) ^ (p >>> 19 | p << 13) ^ p >>> 10, v = ((p = e[y - 15]) >>> 7 | p << 25) ^ (p >>> 18 | p << 14) ^ p >>> 3, e[y] = (b + e[y - 7] | 0) + (v + e[y - 16] | 0);
          for (y = 0; y < 64; y++) b = (((u >>> 6 | u << 26) ^ (u >>> 11 | u << 21) ^ (u >>> 25 | u << 7)) + (u & h ^ ~u & l) | 0) + (d + (t[y] + e[y] | 0) | 0) | 0, v = ((s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10)) + (s & a ^ s & c ^ a & c) | 0, d = l, l = h, h = u, u = f + b | 0, f = c, c = a, a = s, s = b + v | 0;
          r[0] += s, r[1] += a, r[2] += c, r[3] += f, r[4] += u, r[5] += h, r[6] += l, r[7] += d, o += 64, i -= 64;
        }
        return o;
      }
      var n = function () {
        function t() {
          this.digestLength = e.digestLength, this.blockSize = e.blockSize, this.state = new Int32Array(8), this.temp = new Int32Array(64), this.buffer = new Uint8Array(128), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1, this.reset();
        }
        return t.prototype.reset = function () {
          return this.state[0] = 1779033703, this.state[1] = 3144134277, this.state[2] = 1013904242, this.state[3] = 2773480762, this.state[4] = 1359893119, this.state[5] = 2600822924, this.state[6] = 528734635, this.state[7] = 1541459225, this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1, this;
        }, t.prototype.clean = function () {
          for (var e = 0; e < this.buffer.length; e++) this.buffer[e] = 0;
          for (e = 0; e < this.temp.length; e++) this.temp[e] = 0;
          this.reset();
        }, t.prototype.update = function (e, t) {
          if (void 0 === t && (t = e.length), this.finished) throw new Error("SHA256: can't update because hash was finished.");
          var n = 0;
          if (this.bytesHashed += t, this.bufferLength > 0) {
            for (; this.bufferLength < 64 && t > 0;) this.buffer[this.bufferLength++] = e[n++], t--;
            64 === this.bufferLength && (r(this.temp, this.state, this.buffer, 0, 64), this.bufferLength = 0);
          }
          for (t >= 64 && (n = r(this.temp, this.state, e, n, t), t %= 64); t > 0;) this.buffer[this.bufferLength++] = e[n++], t--;
          return this;
        }, t.prototype.finish = function (e) {
          if (!this.finished) {
            var t = this.bytesHashed,
              n = this.bufferLength,
              o = t / 536870912 | 0,
              i = t << 3,
              s = t % 64 < 56 ? 64 : 128;
            this.buffer[n] = 128;
            for (var a = n + 1; a < s - 8; a++) this.buffer[a] = 0;
            this.buffer[s - 8] = o >>> 24 & 255, this.buffer[s - 7] = o >>> 16 & 255, this.buffer[s - 6] = o >>> 8 & 255, this.buffer[s - 5] = o >>> 0 & 255, this.buffer[s - 4] = i >>> 24 & 255, this.buffer[s - 3] = i >>> 16 & 255, this.buffer[s - 2] = i >>> 8 & 255, this.buffer[s - 1] = i >>> 0 & 255, r(this.temp, this.state, this.buffer, 0, s), this.finished = !0;
          }
          for (a = 0; a < 8; a++) e[4 * a + 0] = this.state[a] >>> 24 & 255, e[4 * a + 1] = this.state[a] >>> 16 & 255, e[4 * a + 2] = this.state[a] >>> 8 & 255, e[4 * a + 3] = this.state[a] >>> 0 & 255;
          return this;
        }, t.prototype.digest = function () {
          var e = new Uint8Array(this.digestLength);
          return this.finish(e), e;
        }, t.prototype._saveState = function (e) {
          for (var t = 0; t < this.state.length; t++) e[t] = this.state[t];
        }, t.prototype._restoreState = function (e, t) {
          for (var r = 0; r < this.state.length; r++) this.state[r] = e[r];
          this.bytesHashed = t, this.finished = !1, this.bufferLength = 0;
        }, t;
      }();
      e.Hash = n;
      var o = function () {
        function e(e) {
          this.inner = new n(), this.outer = new n(), this.blockSize = this.inner.blockSize, this.digestLength = this.inner.digestLength;
          var t = new Uint8Array(this.blockSize);
          if (e.length > this.blockSize) new n().update(e).finish(t).clean();else for (var r = 0; r < e.length; r++) t[r] = e[r];
          for (r = 0; r < t.length; r++) t[r] ^= 54;
          this.inner.update(t);
          for (r = 0; r < t.length; r++) t[r] ^= 106;
          this.outer.update(t), this.istate = new Uint32Array(8), this.ostate = new Uint32Array(8), this.inner._saveState(this.istate), this.outer._saveState(this.ostate);
          for (r = 0; r < t.length; r++) t[r] = 0;
        }
        return e.prototype.reset = function () {
          return this.inner._restoreState(this.istate, this.inner.blockSize), this.outer._restoreState(this.ostate, this.outer.blockSize), this;
        }, e.prototype.clean = function () {
          for (var e = 0; e < this.istate.length; e++) this.ostate[e] = this.istate[e] = 0;
          this.inner.clean(), this.outer.clean();
        }, e.prototype.update = function (e) {
          return this.inner.update(e), this;
        }, e.prototype.finish = function (e) {
          return this.outer.finished ? this.outer.finish(e) : (this.inner.finish(e), this.outer.update(e, this.digestLength).finish(e)), this;
        }, e.prototype.digest = function () {
          var e = new Uint8Array(this.digestLength);
          return this.finish(e), e;
        }, e;
      }();
      function i(e) {
        var t = new n().update(e),
          r = t.digest();
        return t.clean(), r;
      }
      function s(e, t) {
        var r = new o(e).update(t),
          n = r.digest();
        return r.clean(), n;
      }
      function a(e, t, r, n) {
        var o = n[0];
        if (0 === o) throw new Error("hkdf: cannot expand more");
        t.reset(), o > 1 && t.update(e), r && t.update(r), t.update(n), t.finish(e), n[0]++;
      }
      e.HMAC = o, e.hash = i, e.default = i, e.hmac = s;
      var c = new Uint8Array(e.digestLength);
      function f(e, t, r, n) {
        void 0 === t && (t = c), void 0 === n && (n = 32);
        for (var i = new Uint8Array([1]), f = s(t, e), u = new o(f), h = new Uint8Array(u.digestLength), l = h.length, d = new Uint8Array(n), p = 0; p < n; p++) l === h.length && (a(h, u, r, i), l = 0), d[p] = h[l++];
        return u.clean(), h.fill(0), i.fill(0), d;
      }
      function u(e, t, r, n) {
        for (var i = new o(e), s = i.digestLength, a = new Uint8Array(4), c = new Uint8Array(s), f = new Uint8Array(s), u = new Uint8Array(n), h = 0; h * s < n; h++) {
          var l = h + 1;
          a[0] = l >>> 24 & 255, a[1] = l >>> 16 & 255, a[2] = l >>> 8 & 255, a[3] = l >>> 0 & 255, i.reset(), i.update(t), i.update(a), i.finish(f);
          for (var d = 0; d < s; d++) c[d] = f[d];
          for (d = 2; d <= r; d++) {
            i.reset(), i.update(f).finish(f);
            for (var p = 0; p < s; p++) c[p] ^= f[p];
          }
          for (d = 0; d < s && h * s + d < n; d++) u[h * s + d] = c[d];
        }
        for (h = 0; h < s; h++) c[h] = f[h] = 0;
        for (h = 0; h < 4; h++) a[h] = 0;
        return i.clean(), u;
      }
      e.hkdf = f, e.pbkdf2 = u;
    }(n);
    var o = n.default;
    for (var i in n) o[i] = n[i];
    e.exports = o;
  }();
});
!function (e) {
  function t() {}
  function r() {}
  var n = String.fromCharCode,
    o = {}.toString,
    i = o.call(e.SharedArrayBuffer),
    s = o(),
    a = e.Uint8Array,
    c = a || Array,
    f = a ? ArrayBuffer : c,
    u = f.isView || function (e) {
      return e && "length" in e;
    },
    h = o.call(f.prototype);
  f = r.prototype;
  var l = e.TextEncoder,
    d = new (a ? Uint16Array : c)(32);
  t.prototype.decode = function (e) {
    if (!u(e)) {
      var t = o.call(e);
      if (t !== h && t !== i && t !== s) throw TypeError("Failed to execute 'decode' on 'TextDecoder': The provided value is not of type '(ArrayBuffer or ArrayBufferView)'");
      e = a ? new c(e) : e || [];
    }
    for (var r, f, l, p = t = "", y = 0, g = 0 | e.length, b = g - 32 | 0, v = 0, w = 0, m = 0, A = -1; y < g;) {
      for (r = y <= b ? 32 : g - y | 0; m < r; y = y + 1 | 0, m = m + 1 | 0) {
        switch ((f = 255 & e[y]) >> 4) {
          case 15:
            if (2 != (l = 255 & e[y = y + 1 | 0]) >> 6 || 247 < f) {
              y = y - 1 | 0;
              break;
            }
            v = (7 & f) << 6 | 63 & l, w = 5, f = 256;
          case 14:
            v <<= 6, v |= (15 & f) << 6 | 63 & (l = 255 & e[y = y + 1 | 0]), w = 2 == l >> 6 ? w + 4 | 0 : 24, f = f + 256 & 768;
          case 13:
          case 12:
            v <<= 6, v |= (31 & f) << 6 | 63 & (l = 255 & e[y = y + 1 | 0]), w = w + 7 | 0, y < g && 2 == l >> 6 && v >> w && 1114112 > v ? (f = v, 0 <= (v = v - 65536 | 0) && (A = 55296 + (v >> 10) | 0, f = 56320 + (1023 & v) | 0, 31 > m ? (d[m] = A, m = m + 1 | 0, A = -1) : (l = A, A = f, f = l))) : (y = y - (f >>= 8) - 1 | 0, f = 65533), v = w = 0, r = y <= b ? 32 : g - y | 0;
          default:
            d[m] = f;
            continue;
          case 11:
          case 10:
          case 9:
          case 8:
        }
        d[m] = 65533;
      }
      if (p += n(d[0], d[1], d[2], d[3], d[4], d[5], d[6], d[7], d[8], d[9], d[10], d[11], d[12], d[13], d[14], d[15], d[16], d[17], d[18], d[19], d[20], d[21], d[22], d[23], d[24], d[25], d[26], d[27], d[28], d[29], d[30], d[31]), 32 > m && (p = p.slice(0, m - 32 | 0)), y < g) {
        if (d[0] = A, m = ~A >>> 31, A = -1, p.length < t.length) continue;
      } else -1 !== A && (p += n(A));
      t += p, p = "";
    }
    return t;
  }, f.encode = function (e) {
    var t,
      r = 0 | (e = void 0 === e ? "" : "" + e).length,
      n = new c(8 + (r << 1) | 0),
      o = 0,
      i = !a;
    for (t = 0; t < r; t = t + 1 | 0, o = o + 1 | 0) {
      var s = 0 | e.charCodeAt(t);
      if (127 >= s) n[o] = s;else {
        if (2047 >= s) n[o] = 192 | s >> 6;else {
          e: {
            if (55296 <= s) if (56319 >= s) {
              var f = 0 | e.charCodeAt(t = t + 1 | 0);
              if (56320 <= f && 57343 >= f) {
                if (65535 < (s = (s << 10) + f - 56613888 | 0)) {
                  n[o] = 240 | s >> 18, n[o = o + 1 | 0] = 128 | s >> 12 & 63, n[o = o + 1 | 0] = 128 | s >> 6 & 63, n[o = o + 1 | 0] = 128 | 63 & s;
                  continue;
                }
                break e;
              }
              s = 65533;
            } else 57343 >= s && (s = 65533);
            !i && t << 1 < o && t << 1 < (o - 7 | 0) && (i = !0, (f = new c(3 * r)).set(n), n = f);
          }
          n[o] = 224 | s >> 12, n[o = o + 1 | 0] = 128 | s >> 6 & 63;
        }
        n[o = o + 1 | 0] = 128 | 63 & s;
      }
    }
    return a ? n.subarray(0, o) : n.slice(0, o);
  }, l || (e.TextDecoder = t, e.TextEncoder = r);
}("" + void 0 == typeof t ? "" + void 0 == typeof self ? t : self : t);
var i = function i(e) {
    if (e.length >= 255) throw new TypeError("Alphabet too long");
    for (var t = new Uint8Array(256), r = 0; r < t.length; r++) t[r] = 255;
    for (var n = 0; n < e.length; n++) {
      var o = e.charAt(n),
        i = o.charCodeAt(0);
      if (255 !== t[i]) throw new TypeError(o + " is ambiguous");
      t[i] = n;
    }
    var s = e.length,
      a = e.charAt(0),
      c = Math.log(s) / Math.log(256),
      f = Math.log(256) / Math.log(s);
    function u(e) {
      if ("string" != typeof e) throw new TypeError("Expected String");
      if (0 === e.length) return new Uint8Array();
      var r = 0;
      if (" " !== e[r]) {
        for (var n = 0, o = 0; e[r] === a;) n++, r++;
        for (var i = (e.length - r) * c + 1 >>> 0, f = new Uint8Array(i); e[r];) {
          var u = t[e.charCodeAt(r)];
          if (255 === u) return;
          for (var h = 0, l = i - 1; (0 !== u || h < o) && -1 !== l; l--, h++) u += s * f[l] >>> 0, f[l] = u % 256 >>> 0, u = u / 256 >>> 0;
          if (0 !== u) throw new Error("Non-zero carry");
          o = h, r++;
        }
        if (" " !== e[r]) {
          for (var d = i - o; d !== i && 0 === f[d];) d++;
          for (var p = new Uint8Array(n + (i - d)), y = n; d !== i;) p[y++] = f[d++];
          return p;
        }
      }
    }
    return {
      encode: function encode(t) {
        if (t instanceof Uint8Array || (ArrayBuffer.isView(t) ? t = new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : Array.isArray(t) && (t = Uint8Array.from(t))), !(t instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (0 === t.length) return "";
        for (var r = 0, n = 0, o = 0, i = t.length; o !== i && 0 === t[o];) o++, r++;
        for (var c = (i - o) * f + 1 >>> 0, u = new Uint8Array(c); o !== i;) {
          for (var h = t[o], l = 0, d = c - 1; (0 !== h || l < n) && -1 !== d; d--, l++) h += 256 * u[d] >>> 0, u[d] = h % s >>> 0, h = h / s >>> 0;
          if (0 !== h) throw new Error("Non-zero carry");
          n = l, o++;
        }
        for (var p = c - n; p !== c && 0 === u[p];) p++;
        for (var y = a.repeat(r); p < c; ++p) y += e.charAt(u[p]);
        return y;
      },
      decodeUnsafe: u,
      decode: function decode(e) {
        var t = u(e);
        if (t) return t;
        throw new Error("Non-base" + s + " character");
      }
    };
  },
  s = function s(e) {
    return e && "object" == typeof e && "function" == typeof e.copy && "function" == typeof e.fill && "function" == typeof e.readUInt8;
  },
  a = n(function (e) {
    "function" == typeof Object.create ? e.exports = function (e, t) {
      e.super_ = t, e.prototype = Object.create(t.prototype, {
        constructor: {
          value: e,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      });
    } : e.exports = function (e, t) {
      e.super_ = t;
      var r = function r() {};
      r.prototype = t.prototype, e.prototype = new r(), e.prototype.constructor = e;
    };
  }),
  c = n(function (e, t) {
    var r = Object.getOwnPropertyDescriptors || function (e) {
        for (var t = Object.keys(e), r = {}, n = 0; n < t.length; n++) r[t[n]] = Object.getOwnPropertyDescriptor(e, t[n]);
        return r;
      },
      n = /%[sdj%]/g;
    t.format = function (e) {
      if (!v(e)) {
        for (var t = [], r = 0; r < arguments.length; r++) t.push(c(arguments[r]));
        return t.join(" ");
      }
      r = 1;
      for (var o = arguments, i = o.length, s = String(e).replace(n, function (e) {
          if ("%%" === e) return "%";
          if (r >= i) return e;
          switch (e) {
            case "%s":
              return String(o[r++]);
            case "%d":
              return Number(o[r++]);
            case "%j":
              try {
                return JSON.stringify(o[r++]);
              } catch (e) {
                return "[Circular]";
              }
            default:
              return e;
          }
        }), a = o[r]; r < i; a = o[++r]) g(a) || !A(a) ? s += " " + a : s += " " + c(a);
      return s;
    }, t.deprecate = function (e, r) {
      if ("undefined" != typeof process && !0 === process.noDeprecation) return e;
      if ("undefined" == typeof process) return function () {
        return t.deprecate(e, r).apply(this, arguments);
      };
      var n = !1;
      return function () {
        if (!n) {
          if (process.throwDeprecation) throw new Error(r);
          process.traceDeprecation ? console.trace(r) : console.error(r), n = !0;
        }
        return e.apply(this, arguments);
      };
    };
    var o,
      i = {};
    function c(e, r) {
      var n = {
        seen: [],
        stylize: u
      };
      return arguments.length >= 3 && (n.depth = arguments[2]), arguments.length >= 4 && (n.colors = arguments[3]), y(r) ? n.showHidden = r : r && t._extend(n, r), w(n.showHidden) && (n.showHidden = !1), w(n.depth) && (n.depth = 2), w(n.colors) && (n.colors = !1), w(n.customInspect) && (n.customInspect = !0), n.colors && (n.stylize = f), h(n, e, n.depth);
    }
    function f(e, t) {
      var r = c.styles[t];
      return r ? "[" + c.colors[r][0] + "m" + e + "[" + c.colors[r][1] + "m" : e;
    }
    function u(e, t) {
      return e;
    }
    function h(e, r, n) {
      if (e.customInspect && r && S(r.inspect) && r.inspect !== t.inspect && (!r.constructor || r.constructor.prototype !== r)) {
        var o = r.inspect(n, e);
        return v(o) || (o = h(e, o, n)), o;
      }
      var i = function (e, t) {
        if (w(t)) return e.stylize("undefined", "undefined");
        if (v(t)) {
          var r = "'" + JSON.stringify(t).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
          return e.stylize(r, "string");
        }
        if (b(t)) return e.stylize("" + t, "number");
        if (y(t)) return e.stylize("" + t, "boolean");
        if (g(t)) return e.stylize("null", "null");
      }(e, r);
      if (i) return i;
      var s = Object.keys(r),
        a = function (e) {
          var t = {};
          return e.forEach(function (e, r) {
            t[e] = !0;
          }), t;
        }(s);
      if (e.showHidden && (s = Object.getOwnPropertyNames(r)), E(r) && (s.indexOf("message") >= 0 || s.indexOf("description") >= 0)) return l(r);
      if (0 === s.length) {
        if (S(r)) {
          var c = r.name ? ": " + r.name : "";
          return e.stylize("[Function" + c + "]", "special");
        }
        if (m(r)) return e.stylize(RegExp.prototype.toString.call(r), "regexp");
        if (x(r)) return e.stylize(Date.prototype.toString.call(r), "date");
        if (E(r)) return l(r);
      }
      var f,
        u = "",
        A = !1,
        U = ["{", "}"];
      (p(r) && (A = !0, U = ["[", "]"]), S(r)) && (u = " [Function" + (r.name ? ": " + r.name : "") + "]");
      return m(r) && (u = " " + RegExp.prototype.toString.call(r)), x(r) && (u = " " + Date.prototype.toUTCString.call(r)), E(r) && (u = " " + l(r)), 0 !== s.length || A && 0 != r.length ? n < 0 ? m(r) ? e.stylize(RegExp.prototype.toString.call(r), "regexp") : e.stylize("[Object]", "special") : (e.seen.push(r), f = A ? function (e, t, r, n, o) {
        for (var i = [], s = 0, a = t.length; s < a; ++s) z(t, String(s)) ? i.push(d(e, t, r, n, String(s), !0)) : i.push("");
        return o.forEach(function (o) {
          o.match(/^\d+$/) || i.push(d(e, t, r, n, o, !0));
        }), i;
      }(e, r, n, a, s) : s.map(function (t) {
        return d(e, r, n, a, t, A);
      }), e.seen.pop(), function (e, t, r) {
        if (e.reduce(function (e, t) {
          return t.indexOf("\n"), e + t.replace(/\u001b\[\d\d?m/g, "").length + 1;
        }, 0) > 60) return r[0] + ("" === t ? "" : t + "\n ") + " " + e.join(",\n  ") + " " + r[1];
        return r[0] + t + " " + e.join(", ") + " " + r[1];
      }(f, u, U)) : U[0] + u + U[1];
    }
    function l(e) {
      return "[" + Error.prototype.toString.call(e) + "]";
    }
    function d(e, t, r, n, o, i) {
      var s, a, c;
      if ((c = Object.getOwnPropertyDescriptor(t, o) || {
        value: t[o]
      }).get ? a = c.set ? e.stylize("[Getter/Setter]", "special") : e.stylize("[Getter]", "special") : c.set && (a = e.stylize("[Setter]", "special")), z(n, o) || (s = "[" + o + "]"), a || (e.seen.indexOf(c.value) < 0 ? (a = g(r) ? h(e, c.value, null) : h(e, c.value, r - 1)).indexOf("\n") > -1 && (a = i ? a.split("\n").map(function (e) {
        return "  " + e;
      }).join("\n").substr(2) : "\n" + a.split("\n").map(function (e) {
        return "   " + e;
      }).join("\n")) : a = e.stylize("[Circular]", "special")), w(s)) {
        if (i && o.match(/^\d+$/)) return a;
        (s = JSON.stringify("" + o)).match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (s = s.substr(1, s.length - 2), s = e.stylize(s, "name")) : (s = s.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), s = e.stylize(s, "string"));
      }
      return s + ": " + a;
    }
    function p(e) {
      return Array.isArray(e);
    }
    function y(e) {
      return "boolean" == typeof e;
    }
    function g(e) {
      return null === e;
    }
    function b(e) {
      return "number" == typeof e;
    }
    function v(e) {
      return "string" == typeof e;
    }
    function w(e) {
      return void 0 === e;
    }
    function m(e) {
      return A(e) && "[object RegExp]" === U(e);
    }
    function A(e) {
      return "object" == typeof e && null !== e;
    }
    function x(e) {
      return A(e) && "[object Date]" === U(e);
    }
    function E(e) {
      return A(e) && ("[object Error]" === U(e) || e instanceof Error);
    }
    function S(e) {
      return "function" == typeof e;
    }
    function U(e) {
      return Object.prototype.toString.call(e);
    }
    function j(e) {
      return e < 10 ? "0" + e.toString(10) : e.toString(10);
    }
    t.debuglog = function (e) {
      if (w(o) && (o = process.env.NODE_DEBUG || ""), e = e.toUpperCase(), !i[e]) if (new RegExp("\\b" + e + "\\b", "i").test(o)) {
        var r = process.pid;
        i[e] = function () {
          var n = t.format.apply(t, arguments);
          console.error("%s %d: %s", e, r, n);
        };
      } else i[e] = function () {};
      return i[e];
    }, t.inspect = c, c.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, c.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      regexp: "red"
    }, t.isArray = p, t.isBoolean = y, t.isNull = g, t.isNullOrUndefined = function (e) {
      return null == e;
    }, t.isNumber = b, t.isString = v, t.isSymbol = function (e) {
      return "symbol" == typeof e;
    }, t.isUndefined = w, t.isRegExp = m, t.isObject = A, t.isDate = x, t.isError = E, t.isFunction = S, t.isPrimitive = function (e) {
      return null === e || "boolean" == typeof e || "number" == typeof e || "string" == typeof e || "symbol" == typeof e || void 0 === e;
    }, t.isBuffer = s;
    var O = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    function T() {
      var e = new Date(),
        t = [j(e.getHours()), j(e.getMinutes()), j(e.getSeconds())].join(":");
      return [e.getDate(), O[e.getMonth()], t].join(" ");
    }
    function z(e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }
    t.log = function () {
      console.log("%s - %s", T(), t.format.apply(t, arguments));
    }, t.inherits = a, t._extend = function (e, t) {
      if (!t || !A(t)) return e;
      for (var r = Object.keys(t), n = r.length; n--;) e[r[n]] = t[r[n]];
      return e;
    };
    var D = "undefined" != typeof Symbol ? Symbol("util.promisify.custom") : void 0;
    function L(e, t) {
      if (!e) {
        var r = new Error("Promise was rejected with a falsy value");
        r.reason = e, e = r;
      }
      return t(e);
    }
    t.promisify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
      if (D && e[D]) {
        var t;
        if ("function" != typeof (t = e[D])) throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(t, D, {
          value: t,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), t;
      }
      function t() {
        for (var t, r, n = new Promise(function (e, n) {
            t = e, r = n;
          }), o = [], i = 0; i < arguments.length; i++) o.push(arguments[i]);
        o.push(function (e, n) {
          e ? r(e) : t(n);
        });
        try {
          e.apply(this, o);
        } catch (e) {
          r(e);
        }
        return n;
      }
      return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), D && Object.defineProperty(t, D, {
        value: t,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(t, r(e));
    }, t.promisify.custom = D, t.callbackify = function (e) {
      if ("function" != typeof e) throw new TypeError('The "original" argument must be of type Function');
      function t() {
        for (var t = [], r = 0; r < arguments.length; r++) t.push(arguments[r]);
        var n = t.pop();
        if ("function" != typeof n) throw new TypeError("The last argument must be of type Function");
        var o = this,
          i = function i() {
            return n.apply(o, arguments);
          };
        e.apply(this, t).then(function (e) {
          process.nextTick(i, null, e);
        }, function (e) {
          process.nextTick(L, e, i);
        });
      }
      return Object.setPrototypeOf(t, Object.getPrototypeOf(e)), Object.defineProperties(t, r(e)), t;
    };
  }),
  f = {
    TextEncoder: "undefined" != typeof TextEncoder ? TextEncoder : c.TextEncoder,
    TextDecoder: "undefined" != typeof TextDecoder ? TextDecoder : c.TextDecoder
  };
var u = f.TextEncoder,
  h = f.TextDecoder,
  l = new h(),
  d = new u();
var p = {
  decodeText: function decodeText(e) {
    return l.decode(e);
  },
  encodeText: function encodeText(e) {
    return d.encode(e);
  },
  concat: function concat(e, t) {
    var r = new Uint8Array(t);
    var n = 0;
    var _iterator = _createForOfIteratorHelper(e),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _t = _step.value;
        r.set(_t, n), n += _t.length;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return r;
  }
};
var y = p.encodeText;
var g = /*#__PURE__*/function () {
  function g(e, t, r, n) {
    _classCallCheck(this, g);
    this.name = e, this.code = t, this.codeBuf = y(this.code), this.alphabet = n, this.codec = r(n);
  }
  _createClass(g, [{
    key: "encode",
    value: function encode(e) {
      return this.codec.encode(e);
    }
  }, {
    key: "decode",
    value: function decode(e) {
      var _iterator2 = _createForOfIteratorHelper(e),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _t2 = _step2.value;
          if (this.alphabet && this.alphabet.indexOf(_t2) < 0) throw new Error("invalid character '".concat(_t2, "' in '").concat(e, "'"));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return this.codec.decode(e);
    }
  }]);
  return g;
}();
var b = {
  rfc4648: function rfc4648(e) {
    return function (t) {
      return {
        encode: function encode(r) {
          return function (e, t, r) {
            var n = "=" === t[t.length - 1],
              o = (1 << r) - 1;
            var i = "",
              s = 0,
              a = 0;
            for (var _n = 0; _n < e.length; ++_n) for (a = a << 8 | e[_n], s += 8; s > r;) s -= r, i += t[o & a >> s];
            if (s && (i += t[o & a << r - s]), n) for (; i.length * r & 7;) i += "=";
            return i;
          }(r, t, e);
        },
        decode: function decode(r) {
          return function (e, t, r) {
            var n = {};
            for (var _e = 0; _e < t.length; ++_e) n[t[_e]] = _e;
            var o = e.length;
            for (; "=" === e[o - 1];) --o;
            var i = new Uint8Array(o * r / 8 | 0);
            var s = 0,
              a = 0,
              c = 0;
            for (var _t3 = 0; _t3 < o; ++_t3) {
              var _o = n[e[_t3]];
              if (void 0 === _o) throw new SyntaxError("Invalid character " + e[_t3]);
              a = a << r | _o, s += r, s >= 8 && (s -= 8, i[c++] = 255 & a >> s);
            }
            if (s >= r || 255 & a << 8 - s) throw new SyntaxError("Unexpected end of data");
            return i;
          }(r, t, e);
        }
      };
    };
  }
};
var v = b.rfc4648,
  w = p.decodeText,
  m = p.encodeText,
  A = [["identity", "\0", function () {
    return {
      encode: w,
      decode: m
    };
  }, ""], ["base2", "0", v(1), "01"], ["base8", "7", v(3), "01234567"], ["base10", "9", i, "0123456789"], ["base16", "f", v(4), "0123456789abcdef"], ["base16upper", "F", v(4), "0123456789ABCDEF"], ["base32hex", "v", v(5), "0123456789abcdefghijklmnopqrstuv"], ["base32hexupper", "V", v(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV"], ["base32hexpad", "t", v(5), "0123456789abcdefghijklmnopqrstuv="], ["base32hexpadupper", "T", v(5), "0123456789ABCDEFGHIJKLMNOPQRSTUV="], ["base32", "b", v(5), "abcdefghijklmnopqrstuvwxyz234567"], ["base32upper", "B", v(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"], ["base32pad", "c", v(5), "abcdefghijklmnopqrstuvwxyz234567="], ["base32padupper", "C", v(5), "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567="], ["base32z", "h", v(5), "ybndrfg8ejkmcpqxot1uwisza345h769"], ["base36", "k", i, "0123456789abcdefghijklmnopqrstuvwxyz"], ["base36upper", "K", i, "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ"], ["base58btc", "z", i, "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz"], ["base58flickr", "Z", i, "123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ"], ["base64", "m", v(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"], ["base64pad", "M", v(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="], ["base64url", "u", v(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"], ["base64urlpad", "U", v(6), "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_="]],
  x = A.reduce(function (e, t) {
    return e[t[0]] = new g(t[0], t[1], t[2], t[3]), e;
  }, {}),
  E = A.reduce(function (e, t) {
    return e[t[1]] = x[t[0]], e;
  }, {});
var S = {
    names: x,
    codes: E
  },
  U = n(function (e, t) {
    var r = p.encodeText,
      n = p.decodeText,
      o = p.concat;
    function i(e) {
      if (S.names[e]) return S.names[e];
      if (S.codes[e]) return S.codes[e];
      throw new Error("Unsupported encoding: ".concat(e));
    }
    (t = e.exports = function (e, t) {
      if (!t) throw new Error("requires an encoded Uint8Array");
      var _i = i(e),
        r = _i.name,
        s = _i.codeBuf;
      return function (e, t) {
        i(e).decode(n(t));
      }(r, t), o([s, t], s.length + t.length);
    }).encode = function (e, t) {
      var n = i(e),
        s = r(n.encode(t));
      return o([n.codeBuf, s], n.codeBuf.length + s.length);
    }, t.decode = function (e) {
      e instanceof Uint8Array && (e = n(e));
      var t = e[0];
      return ["f", "F", "v", "V", "t", "T", "b", "B", "c", "C", "h", "k", "K"].includes(t) && (e = e.toLowerCase()), i(e[0]).decode(e.substring(1));
    }, t.isEncoded = function (e) {
      if (e instanceof Uint8Array && (e = n(e)), "[object String]" !== Object.prototype.toString.call(e)) return !1;
      try {
        return i(e[0]).name;
      } catch (e) {
        return !1;
      }
    }, t.encoding = i, t.encodingFromData = function (e) {
      return e instanceof Uint8Array && (e = n(e)), i(e[0]);
    }, t.names = Object.freeze(S.names), t.codes = Object.freeze(S.codes);
  });
var j = !1;
"process" in t && (j = /^v8\./.test(t.process.version));
var O = r(Object.freeze({
    __proto__: null,
    default: {}
  })),
  T = n(function (e) {
    !function (t, r, n) {
      var o,
        i = 256,
        s = n.pow(i, 6),
        a = n.pow(2, 52),
        c = 2 * a,
        f = 255;
      function u(e, f, u) {
        var g = [],
          b = p(d((f = 1 == f ? {
            entropy: !0
          } : f || {}).entropy ? [e, y(r)] : null == e ? function () {
            try {
              var e;
              return o && (e = o.randomBytes) ? e = e(i) : (e = new Uint8Array(i), (t.crypto || t.msCrypto).getRandomValues(e)), y(e);
            } catch (e) {
              var n = t.navigator,
                s = n && n.plugins;
              return [+new Date(), t, s, t.screen, y(r)];
            }
          }() : e, 3), g),
          v = new h(g),
          w = function w() {
            for (var e = v.g(6), t = s, r = 0; e < a;) e = (e + r) * i, t *= i, r = v.g(1);
            for (; e >= c;) e /= 2, t /= 2, r >>>= 1;
            return (e + r) / t;
          };
        return w.int32 = function () {
          return 0 | v.g(4);
        }, w.quick = function () {
          return v.g(4) / 4294967296;
        }, w.double = w, p(y(v.S), r), (f.pass || u || function (e, t, r, o) {
          return o && (o.S && l(o, v), e.state = function () {
            return l(v, {});
          }), r ? (n.random = e, t) : e;
        })(w, b, "global" in f ? f.global : this == n, f.state);
      }
      function h(e) {
        var t,
          r = e.length,
          n = this,
          o = 0,
          s = n.i = n.j = 0,
          a = n.S = [];
        for (r || (e = [r++]); o < i;) a[o] = o++;
        for (o = 0; o < i; o++) a[o] = a[s = f & s + e[o % r] + (t = a[o])], a[s] = t;
        (n.g = function (e) {
          for (var t, r = 0, o = n.i, s = n.j, a = n.S; e--;) t = a[o = f & o + 1], r = r * i + a[f & (a[o] = a[s = f & s + t]) + (a[s] = t)];
          return n.i = o, n.j = s, r;
        })(i);
      }
      function l(e, t) {
        return t.i = e.i, t.j = e.j, t.S = e.S.slice(), t;
      }
      function d(e, t) {
        var r,
          n = [],
          o = typeof e;
        if (t && "object" == o) for (r in e) try {
          n.push(d(e[r], t - 1));
        } catch (e) {}
        return n.length ? n : "string" == o ? e : e + "\0";
      }
      function p(e, t) {
        for (var r, n = e + "", o = 0; o < n.length;) t[f & o] = f & (r ^= 19 * t[f & o]) + n.charCodeAt(o++);
        return y(t);
      }
      function y(e) {
        return String.fromCharCode.apply(0, e);
      }
      if (p(n.random(), r), e.exports) {
        e.exports = u;
        try {
          o = O;
        } catch (e) {}
      } else n.seedrandom = u;
    }("undefined" != typeof self ? self : t, [], Math);
  });
var z = function z(e) {
    var t = T;
    var r, n;
    try {
      r = (o = "require", i = "react-native", e[o](i)).NativeModules.SyncRandomBytes, r && (n = r.seed);
    } catch (e) {}
    var o, i;
    !n && e && "Expo" in e && (n = function (e) {
      var t = e.reduce(function (e, t) {
          return e + 2 * t.length;
        }, 0),
        r = new ArrayBuffer(t),
        n = new Uint16Array(r);
      var o = 0;
      return e.forEach(function (e) {
        for (var t = 0, r = e.length; t < r; t++) n[o + t] = e.charCodeAt(t);
        o += e.length;
      }), n;
    }([e.Expo.Constants.installationId, e.Expo.Constants.sessionId, "performance" in e ? e.performance.now().toString(32) : new Date().toISOString(), Math.random().toString(32)]));
    var s = t(n),
      a = !1;
    function c(e) {
      if (e.length > 65536) throw new Error("QuotaExceeded");
      for (var _t4 = (.25 * e.length + 1 | 0) - 1, _r = 0; _t4 >= 0; _t4--) {
        var _t5 = s.int32();
        e[_r++] = 255 & _t5, e[_r++] = _t5 >> 8 & 255, e[_r++] = _t5 >> 16 & 255, e[_r++] = _t5 >> 24 & 255;
      }
      return e;
    }
    return !n && r && (a = !0, r.randomBytes().then(function (e) {
      a = !1, s = t(e);
    }).catch(function (e) {
      a = !1, console.log("WARNING: can not collect seed data: ".concat(e.message));
    })), function (e) {
      if (a && (a = !1, console.log("WARNING: random data is requested before the seed is done")), null == e) throw new Error("invalid type");
      if (e instanceof Uint8Array) return c(e);
      if (e instanceof Uint32Array) return function (e) {
        var t = e.length;
        if (t > 16384) throw new Error("QuotaExceeded");
        for (var _r2 = t - 1; _r2 >= 0; _r2--) e[_r2] = s.int32();
        return e;
      }(e);
      if (e instanceof Uint16Array) return function (e) {
        if (e.length > 32767) throw new Error("QuotaExceeded");
        for (var _t6 = (.5 * e.length + 1 | 0) - 1, _r3 = 0; _t6 >= 0; _t6--) {
          var _t7 = s.int32();
          e[_r3++] = 65535 & _t7, e[_r3++] = _t7 >> 16 & 65535;
        }
        return e;
      }(e);
      if (e instanceof Int32Array) return function (e) {
        var t = e.length;
        if (t > 16384) throw new Error("QuotaExceeded");
        for (var _r4 = t - 1; _r4 >= 0; _r4--) e[_r4] = s.int32() - 2147483648;
        return e;
      }(e);
      if (e instanceof Int16Array) return function (e) {
        if (e.length > 32767) throw new Error("QuotaExceeded");
        for (var _t8 = (.5 * e.length + 1 | 0) - 1, _r5 = 0; _t8 >= 0; _t8--) {
          var _t9 = s.int32();
          e[_r5++] = (65535 & _t9) - 32768, e[_r5++] = (_t9 >> 16 & 65535) - 32768;
        }
        return e;
      }(e);
      if (e instanceof Int8Array) return function (e) {
        if (e.length > 65536) throw new Error("QuotaExceeded");
        for (var _t10 = (.25 * e.length + 1 | 0) - 1, _r6 = 0; _t10 >= 0; _t10--) {
          var _t11 = s.int32();
          e[_r6++] = (255 & _t11) - 128, e[_r6++] = (_t11 >> 8 & 255) - 128, e[_r6++] = (_t11 >> 16 & 255) - 128, e[_r6++] = (_t11 >> 24 & 255) - 128;
        }
        return e;
      }(e);
      if (e instanceof Uint8ClampedArray) return c(e);
      throw new Error("invalid type");
    };
  },
  D = n(function (e) {
    e.exports = function (e) {
      if (e && e.crypto && e.crypto.getRandomValues) return e.crypto.getRandomValues.bind(e.crypto);
      try {
        return function (e) {
          var t = (r = "crypto", e.require(r));
          var r;
          function n(e, t) {
            var r = e.length;
            for (var _n2 = 0, _o2 = 0; _n2 < r; _n2++) e[_n2] = t[_o2++] << 24 | t[_o2++] << 16 | t[_o2++] << 8 | t[_o2++];
            return e;
          }
          function o(e, t) {
            var r = e.length;
            for (var _n3 = 0, _o3 = 0; _n3 < r; _n3++) e[_n3] = (t[_o3++] << 24 | t[_o3++] << 16 | t[_o3++] << 8 | t[_o3++]) - 2147483648;
            return e;
          }
          function i(e, t) {
            var r = e.length;
            for (var _n4 = 0, _o4 = 0; _n4 < r; _n4++) e[_n4] = t[_o4++] << 8 | t[_o4++];
            return e;
          }
          function s(e, t) {
            var r = e.length;
            for (var _n5 = 0, _o5 = 0; _n5 < r; _n5++) e[_n5] = (t[_o5++] << 8 | t[_o5++]) - 32768;
            return e;
          }
          function a(e, t) {
            var r = e.length;
            for (var _n6 = 0; _n6 < r; _n6++) e[_n6] = t[_n6];
            return e;
          }
          function c(e, t) {
            var r = e.length;
            for (var _n7 = 0; _n7 < r; _n7++) e[_n7] = t[_n7] - 128;
            return e;
          }
          return j ? function (e) {
            if (e instanceof Uint8Array) return t.randomFillSync(e);
            var r = t.randomBytes(e.byteLength);
            if (e instanceof Uint32Array) return n(e, r);
            if (e instanceof Uint16Array) return i(e, r);
            if (e instanceof Int32Array) return o(e, r);
            if (e instanceof Int16Array) return s(e, r);
            if (e instanceof Int8Array) return c(e, r);
            if (e instanceof Uint8ClampedArray) return a(e, r);
            throw new Error("invalid type");
          } : t.randomFillSync || function (e) {
            var r = t.randomBytes(e.byteLength);
            if (e instanceof Uint8Array) return a(e, r);
            if (e instanceof Uint32Array) return n(e, r);
            if (e instanceof Uint16Array) return i(e, r);
            if (e instanceof Int32Array) return o(e, r);
            if (e instanceof Int16Array) return s(e, r);
            if (e instanceof Int8Array) return c(e, r);
            if (e instanceof Uint8ClampedArray) return a(e, r);
            throw new Error("invalid type");
          };
        }(e);
      } catch (t) {
        return z(e);
      }
    }("object" == typeof window ? window : e);
  });
var L = {
    invalidKeyError: new Error("Invalid key")
  },
  k = function k(e) {
    return D(new Uint8Array(e));
  },
  C = function C(e) {
    return U.decode(e);
  },
  B = function B(e) {
    return new TextDecoder().decode(U.encode("base32", e));
  };
var I = /*#__PURE__*/function () {
  function I(e, t) {
    _classCallCheck(this, I);
    this.service = e, this.read = t;
  }
  _createClass(I, [{
    key: "isDefined",
    value: function isDefined() {
      return void 0 !== this.service;
    }
  }, {
    key: "canRead",
    value: function canRead() {
      return void 0 !== this.read;
    }
  }, {
    key: "toBytes",
    value: function toBytes() {
      var e;
      if (void 0 !== this.read) {
        var _t12 = new Uint8Array(this.service.byteLength + (null !== (e = this.read.byteLength) && void 0 !== e ? e : 0));
        return _t12.set(this.service), this.read && _t12.set(this.read, this.service.byteLength), _t12;
      }
      return this.service;
    }
  }, {
    key: "toString",
    value: function toString() {
      return B(this.toBytes());
    }
  }], [{
    key: "fromRandom",
    value: function fromRandom() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !0;
      return new I(k(32), e ? k(32) : void 0);
    }
  }, {
    key: "fromBytes",
    value: function fromBytes(e) {
      if (32 !== e.byteLength && 64 !== e.byteLength) throw L.invalidKeyError;
      var t = e.slice(0, 32);
      var r;
      return 64 === e.byteLength && (r = e.slice(32)), new I(t, r);
    }
  }, {
    key: "fromString",
    value: function fromString(e) {
      var t = U.decode(e);
      return this.fromBytes(t);
    }
  }]);
  return I;
}();
var P = new TextEncoder(),
  N = new TextDecoder();
function M(t) {
  var r = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Date(Date.now() + 18e5);
  return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
    var e, n, i;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          e = U.decode(t), n = r.toISOString(), i = new o.HMAC(e).update(P.encode(n)).digest();
          return _context.abrupt("return", {
            sig: N.decode(U.encode("base32", i)),
            msg: n
          });
        case 2:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
}
function F(t, r, n, o) {
  return e(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
    var e;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return M(r, n);
        case 2:
          e = _context2.sent;
          return _context2.abrupt("return", Object.assign(Object.assign({}, e), {
            key: t,
            token: o
          }));
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
}
export { I as ThreadKey, M as createAPISig, F as createUserAuth, L as errors, C as keyFromString, B as keyToString, k as randomBytes };